import React from 'react';
import PropTypes from 'prop-types';

import { FooterSection, FooterSectionProps } from './FooterSection';
import { FooterItem, FooterItemProps } from './FooterItem';
import { FooterLink, FooterLinkProps } from './FooterLink';
import { FooterIcon, FooterIconProps } from './FooterIcon';
import { FooterWrapper, FooterContent } from './Footer.styles';

export type { FooterSectionProps, FooterItemProps, FooterLinkProps, FooterIconProps };

export type FooterProps = {
  children: React.ReactNode;
  /**
   * Whether the Footer has a top border or not
   * @default true
   */
  hasBorder?: boolean;
  /**
   * Determines the background colour of the Footer
   * @default 'default'
   */
  color?: 'default' | 'transparent';
};

export const Footer = ({
  children,
  color = 'default',
  hasBorder = true,
}: FooterProps): JSX.Element => {
  const hasOnlyOneSection = Array.isArray(children) && children.length === 1;

  return (
    <FooterWrapper color={color} hasBorder={hasBorder}>
      <FooterContent hasOnlyOneSection={hasOnlyOneSection}>{children}</FooterContent>
    </FooterWrapper>
  );
};

Footer.Section = FooterSection;
Footer.Item = FooterItem;
Footer.Link = FooterLink;
Footer.Icon = FooterIcon;

Footer.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  hasBorder: PropTypes.bool,
  className: PropTypes.string,
};
